import React, {useEffect,useId,useRef,useState} from 'react';
import { Slider, Rail, Handles, Tracks, Ticks } from 'react-compound-slider';
import { Handle, Track, Tick } from '../../../components/misc/SliderComp/components';
import { Dialog } from 'primereact/dialog';
import { Button } from 'primereact/button';
import Cargando from '../../../components/misc/Redirect/Cargando';
import  ToLogin from '../../../components/misc/Redirect/ToLogin';
import  Result from '../../../components/misc/Message/Result';
import { IOpcion } from '../../../interfaces/OpcionReembolso';
import { ISolicitudEmpresarial } from '../../../interfaces/ISolicitudEmpresarial'
import { useReembolsoExpressContext } from '../context/reembolsoExpress.context';
import { getCuits, postAdelantar, postDisponiblesPorCuit } from '../services/reembolso.service';
import {  MEDIO_DE_PAGO_DIGITAL, MEDIO_DE_PAGO_TRANSFERENCIA } from '../utilities/constants';
import Confirmar from './Confirmar';
import { setSolicitud } from '../services/empresarial.service';
import { calcularFecha } from '../utilities/date';
import { obtenerTotalPorNeto } from '../utilities/intereses';
import { formatMoney } from '../../shared/utilitties/formatMoney';
import HeaderAdelantos from './HeaderAdelantos';
import SolicitudEmpresarial from './SolicitudEmpresarial';
import TableAdelantar from './TableAdelantar';
import { useGlobalContext } from '../../shared/context/global.context';
import { Toast } from 'primereact/toast';
import { InputText } from 'primereact/inputtext';

interface dataDisponible {
    monto: number,
    reembolso: string,
    presentacion: string,
    acumulado: number,
    fecha: Date,
    diasAdelantoTransferencia: number,
    diasAdelantoEmpresarial: number,
    producto: string,
    cargoAdministrativo: number,
    cargoAdministrativoIva: number,
    cargoAdministrativoBonificacion: number,
    cargoAdministrativoEmpresarial: number,
    cargoAdministrativoIvaEmpresarial: number,
    cargoAdministrativoBonificacionEmpresarial: number,
    cargoFinanciero: number,
    cargoFinancieroIva: number,
    cargoFinancieroPercepciones: number,
    cargoFinancieroBonificacion: number,
    cargoFinancieroEmpresarial: number,
    cargoFinancieroIvaEmpresarial: number,
    cargoFinancieroPercepcionesEmpresarial: number,
    cargoFinancieroBonificacionEmpresarial: number
}
interface IAdelantarRequest {
    PresentacionesArray?: string[],
    Monto: number,
    MetodoPagoId: number,
    CuitRazon: string
}
const sliderStyle: React.CSSProperties = {
    position: 'relative',
    width: '100%'
};

const railStyle: React.CSSProperties = {
    position: 'absolute',
    width: '100%',
    height: 14,
    borderRadius: 7,
    cursor: 'pointer',
    backgroundColor: 'rgb(234, 234, 234)'
};

interface cuits {
    label: string,
    value: string,
}

interface IDisponibleRequest {
    cuit: string
}

interface IState {
    monto: number,
    loading: boolean,
    date: Date,
    update: ReadonlyArray<number>,
    rate: number,
    rateMax: number,
    rateMin: number,
    domain: number[],
    dataDisponible?: dataDisponible[]
    cantReembolsos: number,
    opcion: IOpcion[],
    maxActual: number,
    digital: number,
    transferencia: number,
    redirect: boolean
    url: string,
    reembolsos?: string[],
    dias: number,
    success: boolean,
    //asked: boolean,
    adelantando: boolean
}

interface data {
    reembolsos?: string[],
    dias: number
}
interface dataCuit {
    cuits: cuits[],
    fetchCuit: boolean,
}

const Adelantar = React.memo(() => {
    
    const {users, userSelected,userLogged} = useGlobalContext()
    const reembolsoState = useReembolsoExpressContext()
    const{isEmpresarial,requestedCard,setRequestedCard,adelanto,setAdelanto} = reembolsoState
    const toast = useRef<Toast>(null);
    const [clickAdelantar, setClickAdelantar] = useState(false )
    const [popupEmpresarial,setPopupEmpresarial] = useState(false)
    const [valuesSlider,setValuesSlider] = useState<ReadonlyArray<number>>([0])
    const [finishLoadCuits,setFinishLoadCuits] = useState(true)
    const [montoText,setMontoText] = useState("0,00")
    const [medioPago,setMedioPago] = useState('Transferencia')
    const [cuitSelected, setCuitSelected] = useState("")
    const [state, setState] = useState<IState>({
        loading: true, 
        monto: 0, 
        date: new Date(), 
        update: [0], 
        rate: 0.01, 
        rateMax: 100, 
        rateMin: 0.01,
        domain: [-0.01, 0], 
        cantReembolsos: 0,
        opcion: reembolsoState.state.opcion, 
        maxActual: 0,
        digital: 0, 
        transferencia: 1,
        redirect: false,
        url: "",
        success: false,
        //asked: false,
        dias: 0,
        adelantando: false,
    })
    const [finishFnDisponible,setFinishFnDisponible] = useState(0)
    const [dataInteres,setDataInteres] = useState<data>({dias: 0})
    const [dataCuit,setDataCuit] = useState<dataCuit>({cuits:[],fetchCuit:false})
    const [finishPostDisponiblesPorCuit,setFinishPostDisponiblesPorCuit] = useState(true)
    const [LoadingDataRExpress,setLoadingDataRExpress] = useState(true)
    const[cuitValid,setCuitValid] = useState(false)
    useEffect(()=>{
        (async() => {
            await populateCuitsData()
        })()
    },[])

    useEffect(() => {
        if (finishFnDisponible !== 0) {
            let update2: number[] = [state.opcion[0].adelantoMaximo];
            const { op, update } = opcionUpdate(update2);
            setValuesSlider(update)
            setMontoText(op[0].adelantoMaximo.toLocaleString(undefined, { maximumFractionDigits: 2, minimumFractionDigits: 2 }))
            setState({ 
                ...state, 
                update: update ,
                opcion: op,
                loading: false,
            });
        
        let montoTotal = obtenerTotalPorNeto(update);

        if (medioPago === 'Digital'){
            reembolsoState.setState({...reembolsoState.state, monto: montoTotal[state.digital] });
        }
        else{
            reembolsoState.setState({...reembolsoState.state, monto: montoTotal[state.transferencia] });
        }
        updateOpcion2()
        
        }else{
            setFinishLoadCuits(false)
            setFinishPostDisponiblesPorCuit(false)
            setLoadingDataRExpress(false)
        }
    },[finishFnDisponible])

    const updateOpcion2 = async() => {
        setFinishLoadCuits(false)
        setFinishPostDisponiblesPorCuit(false)
        setLoadingDataRExpress(false)
    }

    const opcionUpdate = (value: readonly number[]) => {
        let update: number[]  = Object.assign([], value);
        
        var adelanto: number = 0;
        var porcentajeAdelanto: number = 0;

        var cargoAdministrativo: number = 0;
        var cargoAdministrativoIva: number = 0;
        //var cargoAdministrativoBonificacion: number = 0;
        var cargoAdministrativoEmpresarial: number = 0;
        var cargoAdministrativoIvaEmpresarial: number = 0;
        //var cargoAdministrativoBonificacionEmpresarial: number = 0;
        var cargoFinanciero: number = 0;
        var cargoFinancieroIva: number = 0;
        var cargoFinancieroPercepciones: number = 0;
        //var cargoFinancieroBonificacion: number = 0;
        var cargoFinancieroEmpresarial: number = 0;
        var cargoFinancieroIvaEmpresarial: number = 0;
        var cargoFinancieroPercepcionesEmpresarial: number = 0;
        //var cargoFinancieroBonificacionEmpresarial: number = 0;

        if (update[0] > state.maxActual) {
            update = [state.maxActual];
        }

        let op = state.opcion;

        if (update[0] > 0) {
            // Total adelanto
            adelanto = update[0];

            if (state.dataDisponible != undefined) {
                state.dataDisponible.forEach(function (item) {
                    if (adelanto > 0) {
                        if (adelanto < item.monto) {
                            // Obtener porcentaje de adelanto
                            porcentajeAdelanto = (adelanto / item.monto) * 100.00;
                            adelanto = 0;
                        } else {
                            porcentajeAdelanto = 100.00;
                            adelanto = adelanto - item.monto;
                        }

                        // Cargos Fijos
                        cargoAdministrativo += item.cargoAdministrativo; // 0
                        cargoAdministrativoIva += item.cargoAdministrativoIva; // 1
                        //cargoAdministrativoBonificacion += item.cargoAdministrativoBonificacion; // 2
                        cargoAdministrativoEmpresarial += item.cargoAdministrativoEmpresarial; // 3
                        cargoAdministrativoIvaEmpresarial += item.cargoAdministrativoIvaEmpresarial; // 4
                        //cargoAdministrativoBonificacionEmpresarial += item.cargoAdministrativoBonificacionEmpresarial; // 5

                        cargoFinanciero += (item.cargoFinanciero * porcentajeAdelanto) / 100.00; // 6
                        cargoFinancieroIva += (item.cargoFinancieroIva * porcentajeAdelanto) / 100.00; // 7
                        cargoFinancieroPercepciones += (item.cargoFinancieroPercepciones * porcentajeAdelanto) / 100.00; // 8
                        //cargoFinancieroBonificacion += (item.cargoFinancieroBonificacion * porcentajeAdelanto) / 100.00; // 9
                        cargoFinancieroEmpresarial += (item.cargoFinancieroEmpresarial * porcentajeAdelanto) / 100.00; // 10
                        cargoFinancieroIvaEmpresarial += (item.cargoFinancieroIvaEmpresarial * porcentajeAdelanto) / 100.00; // 11
                        cargoFinancieroPercepcionesEmpresarial += (item.cargoFinancieroPercepcionesEmpresarial * porcentajeAdelanto) / 100.00; // 12
                        //cargoFinancieroBonificacionEmpresarial += (item.cargoFinancieroBonificacionEmpresarial * porcentajeAdelanto) / 100.00; // 13
                    }
                });
            }

            // Transferencias
            op[state.transferencia].adelanto = update[0]; // Total adelanto
            op[state.transferencia].gastoAdmin = cargoAdministrativo; // Cargo Administrativo
            op[state.transferencia].intereses = cargoFinanciero;
            op[state.transferencia].IVA = cargoFinancieroIva + cargoAdministrativoIva;
            op[state.transferencia].percepciones = cargoFinancieroPercepciones;
            op[state.transferencia].costoAdelanto = op[state.transferencia].gastoAdmin + op[state.transferencia].intereses + op[state.transferencia].IVA + op[state.transferencia].percepciones;
            op[state.transferencia].montoAcreditar = update[0] - op[state.transferencia].costoAdelanto;

            // Empresarial
            op[state.digital].adelanto = update[0]; // Total adelanto
            op[state.digital].gastoAdmin = cargoAdministrativoEmpresarial;
            op[state.digital].intereses = cargoFinancieroEmpresarial;
            op[state.digital].IVA = cargoFinancieroIvaEmpresarial + cargoAdministrativoIvaEmpresarial;
            op[state.digital].percepciones = cargoFinancieroPercepcionesEmpresarial;
            op[state.digital].costoAdelanto = op[state.digital].gastoAdmin + op[state.digital].intereses + op[state.digital].IVA + op[state.digital].percepciones;
            op[state.digital].montoAcreditar = update[0] - op[state.digital].costoAdelanto;
        }
        else {
            // Transferencias
            op[state.transferencia].adelanto = 0;
            op[state.transferencia].gastoAdmin = 0;
            op[state.transferencia].intereses = 0;
            op[state.transferencia].IVA = 0;
            op[state.transferencia].percepciones = 0;
            op[state.transferencia].costoAdelanto = 0;
            op[state.transferencia].montoAcreditar = 0;

            // Empresarial
            op[state.digital].adelanto = 0;
            op[state.digital].gastoAdmin = 0;
            op[state.digital].intereses = 0;
            op[state.digital].IVA = 0;
            op[state.digital].percepciones = 0;
            op[state.digital].costoAdelanto = 0;
            op[state.digital].montoAcreditar = 0;
        }
        return { op, update };
    }

    const handleResult =() => {
        setClickAdelantar(false)
        setAdelanto("")
    }
    
    const handlePopupEmpresarial = () =>{
        setPopupEmpresarial(false)
    }
  
    const solicitaEmpresarial = (solicitud: ISolicitudEmpresarial) => {
        //setClickAdelantar(true)
        //setRequestedCard(true)
        /*setState({
            ...state,
            asked: true
        });*/
        callBack_SetEmpresarial(solicitud);
    }
    const canceloEmpresarial = () => {
        setClickAdelantar(false)
        setRequestedCard(false)
        /*setState({
            ...state,
            asked: true
        });*/
    }

    const onFocus = () => {
        setState({ ...state, rate: state.rateMin });
    }

    const onAcceptar = (e: any) =>{
        e.preventDefault();
        setClickAdelantar(false)
        setState({ ...state, adelantando: true });
        callBack_reembolso();
    }

    const onCancelar = (e: any) =>{
        e.preventDefault();
        setClickAdelantar(false)
    }

    const onHide = () => {
        setClickAdelantar(false)
    }

    const onChangeMonto = (e: any) => {
        if (e.target.value.length === 1) {
            e.target.value = '0' + e.target.value;
        }
        else if (e.target.value.length === 0) {
            e.target.value = '0'
        }
        if (+e.target.value.replace(",", "").replace(".", "") > 0) {
            setMontoText(parseFloat(e.target.value.replace(/[^\d]/g, '').replace(/(\d\d?)$/, '.$1')).toLocaleString(undefined, { maximumFractionDigits: 2, minimumFractionDigits: 2 }))
            let num = [];
            if ((+e.target.value.replace(",", "").replace(".", "") / 100) > 1) {
                num.push((+e.target.value.replace(",", "").replace(".", "")) / 100);
                onChange(num);
                onUpdate(num);
            }
        }
        else {
            setMontoText("0,00")
            onChange([0]);
            onUpdate([0]);
        }
    };

    const onChange = (values: ReadonlyArray<number>) => {
        setValuesSlider(values)
        setMontoText(formatMoney(values[0]))
    };

    const onUpdate2 = (update2: Array<number>, obj:any) => {
        const { op, update } = opcionUpdate(update2);
        setMontoText(update[0].toLocaleString(undefined, { maximumFractionDigits: 2, minimumFractionDigits: 2 }))
        setState({ 
            ...state, 
            update: update ,
            opcion: op,
            ...obj
        });
        
        let montoTotal = obtenerTotalPorNeto(update);

        if (medioPago === 'Digital'){
            reembolsoState.setState({...reembolsoState.state, monto: montoTotal[state.digital]});
        }
        else{
            reembolsoState.setState({...reembolsoState.state, monto: montoTotal[state.transferencia] });
        }
    }

    const onUpdate = (value: readonly number[]) => {
        const { op, update } = opcionUpdate(value);

        setMontoText(update[0].toLocaleString(undefined, { maximumFractionDigits: 2, minimumFractionDigits: 2 }))
        setState({ 
            ...state, 
            update: update ,
            opcion: op
        });
        
        let montoTotal = obtenerTotalPorNeto(update);

        if (medioPago === 'Digital') {
            reembolsoState.setState({ ...reembolsoState.state, monto: montoTotal[state.digital] });
        }
        else {
            reembolsoState.setState({ ...reembolsoState.state, monto: montoTotal[state.transferencia] });
        }
    }

    const callBack_SetEmpresarial = async(postData: ISolicitudEmpresarial) => {
        let result =  await setSolicitud(postData)
        if(result.status == 200){
            if (result.data.nologin != undefined && result.data.nologin.indexOf("http") > -1) {
                setState({ ...state, redirect: true, url: result.data.nologin });
            }
            else if (result.data.success){
                setPopupEmpresarial(true)
                setClickAdelantar(false)
                setRequestedCard(true)
            }
                
        }
    }

    const obtenerPostDisponiblesPorCuit = async(cuitSelected:string) => {
        if ( cuitSelected ) {
            let postData: IDisponibleRequest = {
                cuit: cuitSelected
            };
            const {data,status} = await postDisponiblesPorCuit(postData)

            if(status === 200 && data.length > 0 ){
                if (data.nologin != undefined && data.nologin.indexOf("http") > -1) {
                    setCuitSelected(cuitSelected)
                    setState({...state, redirect: true, url: data.nologin});
                }
                else {
                    let maxReembolso = data.length > 0 ? (data[data.length - 1].acumulado) : 0;
                    let domainRes: number[] = [0, maxReembolso];
                    setCuitSelected(cuitSelected)
                    
                    let dataPostDisponiblesPorCuit = { domain: domainRes, cantReembolsos: data.length, dataDisponible: data};
                    reembolsoState.setState({...reembolsoState.state,dataDisponible: data});
                    var op = state.opcion;
                    op[state.digital].adelantoMaximo = domainRes[1];
                    op[state.transferencia].adelantoMaximo = domainRes[1];
                    var maxAdelanto = (medioPago === 'Digital' ? op[state.digital].adelantoMaximo : op[state.transferencia].adelantoMaximo);
                    setState({...state, maxActual: maxAdelanto, opcion: op, ...dataPostDisponiblesPorCuit })
                    setFinishFnDisponible(prevFinishFnDisponible => prevFinishFnDisponible + 1);
                }
    
            }else{
                //toast.current?.show({life: 8000, severity: 'warn', summary: 'Message', detail: 'No Existen Pagos Programados'});
                let domainReset: number[] = [-0.8, 0];
                let valuesReset: number[] = [-0.8];
                setValuesSlider(valuesReset)
                setMontoText("0,00");
                setCuitSelected(cuitSelected)
                setState({...state, domain: domainReset, cantReembolsos: 0, maxActual: 0 })
                reembolsoState.setState({...reembolsoState.state,dataDisponible: null});
                //setFinishFnDisponible(0);
                setFinishFnDisponible(prevFinishFnDisponible => prevFinishFnDisponible + 1);
            }

        }
    }

    const callBack_reembolso = async () => {
        if (dataCuit.cuits != undefined) {
            let cuitRazon = dataCuit.cuits.filter(cuit => cuit.value == cuitSelected);
            if (cuitRazon != undefined) {
                let adelanto = (medioPago === 'Digital') ? state.opcion[state.digital].adelanto : state.opcion[state.transferencia].adelanto
                let presentacionesArray = [];
                let sumMonto = 0.0
                for (const item of reembolsoState.state.dataDisponible) {
                    sumMonto += item.monto;
                    presentacionesArray.push(item.reembolso);
                    if (adelanto > sumMonto) 
                        continue;
                    else 
                        break;
                }

                let postData: IAdelantarRequest = {
                    PresentacionesArray: presentacionesArray,
                    Monto: (medioPago === 'Digital' ? state.opcion[state.digital].adelanto : state.opcion[state.transferencia].adelanto),
                    MetodoPagoId: (medioPago === 'Digital' ? 15 : 3),
                    CuitRazon: cuitRazon[0].label
                };
                const result = await postAdelantar(postData)
                if(result.status === 200){
                    if (result.data.nologin != undefined && result.data.nologin.indexOf("http") > -1) {
                        setState({...state, redirect: true, url: result.data.nologin });
                    }
                    else {
                        setState({...state, success: result.data.success, adelantando: false })
                        if (result.data.success){
                            setAdelanto("success")
                        }
                        else{
                            setAdelanto("error")
                        }
                    }

                }else{
                    setAdelanto("error")
                }
            }
        }
        else {
            setAdelanto("error")
        }
    }

    const populateCuitsData = async() => {
            const {data,status} = await getCuits()
            if(status === 200){
                if (data.nologin != undefined && data.nologin.indexOf("http") > -1) {
                    setState({...state, redirect: true, url: data.nologin });
                }
                else {
                    if ( data.length > 0 && data[0].value) {
                        await obtenerPostDisponiblesPorCuit(data[0].value)
                        setDataCuit({ ...dataCuit, cuits: data, fetchCuit: true });
                        setCuitValid(true)
                    }else{
                        //toast.current?.show({life: 10000, severity: 'warn', summary: 'Message', detail: 'No tiene un Cuit registrado'});
                        console.log("comercioSinPresentaciones")
                        setCuitValid(false)
                    }
                }
            }else{
                        //toast.current?.show({life: 10000, severity: 'warn', summary: 'Message', detail: 'error server'});
            }
            
            setFinishLoadCuits(false)
    }

    const onClickTransferencia = () => {
        if ((reembolsoState.state.habilitadoLanet) || (cuitSelected != null && cuitSelected.length > 0))
            if ((reembolsoState.state.habilitadoLanet) || (state.opcion[state.transferencia].permiteExpress &&
                state.opcion[state.transferencia].cupo > state.domain[1])) {
                setMedioPago('Transferencia')
                setState({ ...state, maxActual: state.opcion[state.transferencia].adelantoMaximo })
                if (state.opcion[state.transferencia].adelanto > state.opcion[state.transferencia].adelantoMaximo) {
                    let num: number[] = [state.opcion[state.transferencia].adelantoMaximo];
                    onChange(num);
                    onUpdate(num);
                }
            }
    };

    const onClickDigital = async() => {
        if ((reembolsoState.state.habilitadoLanet) || (cuitSelected != null && cuitSelected.length > 0)){
            if ((reembolsoState.state.habilitadoLanet) || (state.opcion[state.digital].permiteExpress &&
                state.opcion[state.digital].cupo > state.domain[1])) {
                
                if (state.opcion[state.digital].adelanto > state.opcion[state.digital].adelantoMaximo) {
                    let num: number[] = [state.opcion[state.digital].adelantoMaximo];
                    setValuesSlider(num)
                    setMedioPago('Digital')
                    const updateData = { maxActual: state.opcion[state.digital].adelantoMaximo }
                    onUpdate2(num, updateData);
                    
                }else{
                    setMedioPago('Digital')
                    setState({...state, maxActual: state.opcion[state.digital].adelantoMaximo })
                }
            }
        }
    }

    const footer = (
        <div>
            <Button label="Cancelar" icon="pi pi-times" onClick={onCancelar} className="p-button-secondary" />
            <Button label="Confirmar" icon="pi pi-check" onClick={onAcceptar} />
        </div>
    );
    const adelantarPago = () => {
        setClickAdelantar(true)
        setAdelanto("info")
    }
    const generateClassAndstyles = (state: IState, userSelected: any, users: any, reembolsoState: any) => {
        let disable = !(cuitSelected && cuitSelected.length > 0);
        let claseTrans = "";
        let claseEmpre = "";
        let disableAdelantar = false;
        let checkedTransferencia = false;
        let noSelectedUserCuit = false;
        if(cuitSelected === undefined ) return {disable, noSelectedUserCuit, claseTrans, claseEmpre, checkedTransferencia, disableAdelantar }
    
        if (userSelected === "" && !cuitSelected) {
            disableAdelantar = true;
            noSelectedUserCuit = true;
        }
    
        if (users && users.length === 0) {
            claseTrans = "boxBlue";
            claseEmpre = '';
        } else {
    
            if(medioPago === 'Transferencia'){

            }else{
                //digital
            }
            claseTrans = (disable ? '' : medioPago === 'Transferencia' ? 'boxBlue' : '');
            claseEmpre = (disable ? '' : medioPago === 'Digital' ? 'boxBlue' : '');
            claseTrans = (state.opcion[state.transferencia].permiteExpress ? claseTrans : 'boxDisable');
            claseEmpre = (state.opcion[state.digital].permiteExpress ? claseEmpre : 'boxDisable');
    
            claseTrans = (state.opcion[state.transferencia].cupo > state.domain[1] ? claseTrans : 'boxDisable');
            claseEmpre = (state.opcion[state.digital].cupo > state.domain[1] ? claseEmpre : 'boxDisable');
    
            claseTrans = (reembolsoState.state.habilitadoLanet ? (disable ? '' : medioPago === 'Transferencia' ? 'boxBlue' : '') : claseTrans);
            claseEmpre = (reembolsoState.state.habilitadoLanet ? (disable ? '' : medioPago === 'Digital' ? 'boxBlue' : '') : claseEmpre);
    
            let modo = (medioPago === 'Digital' ? 0 : 1);
            disableAdelantar = !((state.opcion[modo].montoAcreditar > 0) &&
                ((claseTrans == 'boxDisable' ? false : medioPago === 'Transferencia') ||
                    (claseEmpre == 'boxDisable' ? false : medioPago === 'Digital')));
    
        }
        return { disable, noSelectedUserCuit, claseTrans, claseEmpre, checkedTransferencia, disableAdelantar };
    }

    if (state.redirect) {
        return <ToLogin url={state.url} />
    }
    else if (state.adelantando || finishLoadCuits) {
        return <Cargando />
    }
    if(finishPostDisponiblesPorCuit){
        return <Cargando />
    }

    if(LoadingDataRExpress){
        return <Cargando />
    }
    
    else {
        
        let { disable, noSelectedUserCuit, claseTrans, claseEmpre, checkedTransferencia, disableAdelantar } = generateClassAndstyles(state, userSelected, users, reembolsoState);    
        if(claseTrans ==="" && claseEmpre === "" && finishLoadCuits){
            return <Cargando />
        }
        
         return (
            <div className="refund-panel-size">
                {/*<Toast ref={toast} position="bottom-right" />        */}
                <div className="row">
                    <div className="col-12">
                        <div className='card mt-2'>
                        <span className="p-float-label">
                        {cuitValid ? <InputText id="username" value={dataCuit.cuits[0].label} style={{width:"100%"}} disabled/> : <></>}
                        </span>
                        
                        </div>
                    </div>
                </div>
                
                <div>
                    <div className={disable ? 'card mt-2 cardDisable fontDisable' : 'card mt-2'}>
                        <HeaderAdelantos
                            domain={state.domain}
                            montoText={montoText}
                            onChangeMonto={onChangeMonto}
                            onFocus={onFocus}
                            disable={disable}
                        />
                        <div className="d-flex justify-content-center align-items-center">
                            <div className="p-col-12">
                                <div style={{ height: 20, width: '100%', paddingBottom: 0, paddingTop: 10 }}>
                                    <Slider mode={1} step={state.rate} domain={state.domain} rootStyle={sliderStyle} onChange={onChange}
                                        onUpdate={onUpdate} values={valuesSlider} onSlideStart={onFocus} disabled={disable || state.cantReembolsos === 0 || userLogged.activeDirectory} >
                                        <Rail>
                                            {({ getRailProps }) => (
                                                <div style={railStyle} {...getRailProps()} />
                                            )}
                                        </Rail>
                                        <Handles>
                                            {({ handles, getHandleProps }) => (
                                                <div className="slider-handles"> 
                                                    {handles.map(handle => (
                                                        <Handle
                                                            key={handle.id}
                                                            handle={handle}
                                                            domain={state.domain}
                                                            getHandleProps={getHandleProps}
                                                            color={disable ? '#c0c0c0' : '#162056'}
                                                        />
                                                    ))}
                                                </div>
                                            )}
                                        </Handles>
                                        <Tracks right={false}>
                                            {({ tracks, getTrackProps }) => (
                                                <div className="slider-tracks">
                                                    {tracks.map(({ id, source, target }) => (
                                                        <Track
                                                            key={id}
                                                            source={source}
                                                            target={target}
                                                            getTrackProps={getTrackProps}
                                                        />
                                                    ))}
                                                </div>
                                            )}
                                        </Tracks>
                                    </Slider>
                                </div>
                            </div>
                        </div>
                        <div className="row n4">
                            <div className="col-6">
                                <p>$0,00</p>
                            </div>
                            <div className="col-6 text-right">
                                <p>${formatMoney(state.domain[1])}</p>
                            </div>
                        </div>
                    </div>
                    <div className={disable ? 'card mt-2 cardDisable fontDisable' : 'card mt-2'}>
                    {
                    noSelectedUserCuit
                    ? 
                    <TableAdelantar
                    claseTrans=""
                    claseEmpre=""
                    opcion={undefined}
                    transferencia={0}
                    digital={0}
                    medioPago=""
                    onClickTransferencia={undefined}
                    onClickDigital={undefined}
                    checkedTransferencia={false}
                    /> 
                    :<TableAdelantar
                    claseTrans={claseTrans}
                    claseEmpre={claseEmpre}
                    opcion={state.opcion}
                    transferencia={state.transferencia}
                    digital={state.digital}
                    medioPago={medioPago}
                    onClickTransferencia={onClickTransferencia}
                    onClickDigital={onClickDigital}
                    checkedTransferencia={checkedTransferencia}
                    />
                    }
                    
                    </div>

                    <div>
                        {
                            popupEmpresarial && <Result
                                accept={handlePopupEmpresarial}
                                title="Pago Express"
                                message="¡Solicitud de tarjeta empresarial realizada con Éxito!"
                                redirect={false}
                                url=""
                                type="success" />
                            
                        }
                        {(medioPago === 'Transferencia' && clickAdelantar) && (
                            <Dialog header="Confirmar Adelanto" visible={true} footer={footer} onHide={onHide} className="dialog-confirmar" blockScroll>
                                <Confirmar opcion={reembolsoState.state.opcion}
                                    modo={MEDIO_DE_PAGO_TRANSFERENCIA}
                                    dias={dataInteres.dias - 1 - state.opcion[MEDIO_DE_PAGO_TRANSFERENCIA].plazo}
                                    nuevaFechaPago={state.opcion[MEDIO_DE_PAGO_TRANSFERENCIA].nuevaFechaPago} />
                            </Dialog>)
                        }

                        {(medioPago === 'Digital' && clickAdelantar && isEmpresarial) && (
                            <Dialog header="Confirmar Adelanto" visible={true} footer={footer} onHide={onHide} className="dialog-confirmar" blockScroll>
                                <Confirmar opcion={reembolsoState.state.opcion}
                                    modo={MEDIO_DE_PAGO_DIGITAL}
                                    dias={dataInteres.dias - 1 - state.opcion[MEDIO_DE_PAGO_DIGITAL].plazo}
                                    nuevaFechaPago={state.opcion[MEDIO_DE_PAGO_DIGITAL].nuevaFechaPago} />
                            </Dialog>)
                        }

                        {  ((medioPago === 'Digital' && clickAdelantar && !isEmpresarial) && requestedCard && adelanto != "") && (
                        <Result
                                accept={handleResult}
                                title="Pago Express"
                                message="¡Ya se creó una solicitud de tarjeta empresarial!"
                                redirect={false}
                                url=""
                                type="info" />)
                        }
                        {
                            ((medioPago === 'Digital' && clickAdelantar && !isEmpresarial) && !requestedCard && adelanto !== "") && (<div>
                                    <Dialog header="Solicitud de Tarjeta Empresarial" visible={true} onHide={onHide} >
                                        <SolicitudEmpresarial canceloEmpresarial={canceloEmpresarial} solicitaEmpresarial={solicitaEmpresarial} />
                                    </Dialog>
                                </div>)
                        }
                        
                        <Button label="Adelantar" type="button" className="btn btn-accept btn-block mt-2" onClick={adelantarPago}
                            disabled={disableAdelantar || clickAdelantar || userLogged.activeDirectory } />
                            {userLogged.activeDirectory && userLogged.activeDirectory && <div className='p-grid p-justify-center p-align-center mt-2'><span >Un usuario Lanet no puede realizar adelantos</span></div>}
                    </div>
                </div>
            </div >
        )
    }
})

export default Adelantar
